var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMobileBlocked)?_c('router-view'):_c('div',{staticClass:"device-blocked"},[_c('div',{staticClass:"device-blocked__card"},[_c('h1',{staticClass:"device-blocked__title"},[_vm._v("请使用电脑端打开")]),_c('p',{staticClass:"device-blocked__desc"},[_vm._v("当前项目仅支持 PC 和 Mac 浏览器访问。")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }